export const PAGE = {
    FINAL_PAGE: 'review'
};

export const FINAL_DECISION = {
    DECLINED: 'decline',
    REVIEW: 'riskReview',
    NEED_MORE_DATA: 'needMoreInfo'
};

export const SECTIONS = {
    BUSINESS_INFO_COLLECTION: 'businessInfoCollection',
    PERSONAL_INFO_COLLECTION: 'personalInfoCollection',
    UBO_COLLECTION: 'UBOInfoCollection',
    MORE_INFO_COLLECTION: 'moreInfoCollection',
    PURPOSE_NATURE_COLLECTION: 'purposeNatureCollection'
};

export const BUSINESS_TYPE = {
    INDIVIDUAL: 'INDIVIDUAL',
    PARTNERSHIP: 'PARTNERSHIP',
    CORPORATION: 'CORPORATION',
    NONPROFIT: 'NONPROFIT',
    GOVERNMENT: 'GOVERNMENT',
    LIMITED: 'PRIVATE_CORPORATION'
};

const firstScreenBySections = {
    businessInfoFirstScreen: 'businessType',
    personalInfoFirstScreen: 'dateOfBirth',
    uboFirstScreen: 'authorizedRepresentative',
    purposeNatureFirstScreen: 'mcc'
};

const screenConfig = {
    signUp: {
        next: 'businessType'
    },
    businessType: {
        next: {
            [BUSINESS_TYPE.INDIVIDUAL]: 'businessInfo',
            [BUSINESS_TYPE.LIMITED]: 'businessRegistered',
            [BUSINESS_TYPE.PARTNERSHIP]: 'businessRegistered',
            [BUSINESS_TYPE.NONPROFIT]: 'businessRegistered'
        },
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    businessRegistered: {
        next: {
            [BUSINESS_TYPE.INDIVIDUAL]: 'businessInfo',
            [BUSINESS_TYPE.LIMITED]: 'businessInfo',
            [BUSINESS_TYPE.PARTNERSHIP]: 'businessInfo',
            [BUSINESS_TYPE.NONPROFIT]: 'nonProfitRegistry'
        }
    },
    nonProfitRegistry: {
        next: 'businessInfo',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    partnershipRegistrationInfo: {
        next: 'businessInfo',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    businessInfo: {
        next: 'businessName',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    businessName: {
        next: {
            confirmed: 'companyRegistrationNumber',
            denied: 'businessAddress'
        },
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    companyRegistrationNumber: {
        next: 'businessAddress',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    businessAddress: {
        next: 'businessPhoneNumber',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    businessPhoneNumber: {
        next: {
            [BUSINESS_TYPE.INDIVIDUAL]: 'checkpoint',
            [BUSINESS_TYPE.LIMITED]: 'countryOfIncorporation',
            [BUSINESS_TYPE.PARTNERSHIP]: 'countryOfIncorporation',
            [BUSINESS_TYPE.NONPROFIT]: 'countryOfIncorporation'
        },
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    countryOfIncorporation: {
        next: {
            usNational: 'ein',
            nonUSNational: 'checkpoint'
        },
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    ein: {
        next: 'backupWithholdingLegalEntity',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    backupWithholdingLegalEntity: {
        next: 'checkpoint',
        section: SECTIONS.BUSINESS_INFO_COLLECTION
    },
    checkpoint: {
        next: {
            businessInfoCompleted: 'dateOfBirth',
            uboSectionCompleted: {
                mcc: 'mcc',
                skipMcc: 'location'
            },
            personalDone: {
                [BUSINESS_TYPE.INDIVIDUAL]: 'mcc',
                [BUSINESS_TYPE.LIMITED]: 'authorizedRepresentative',
                [BUSINESS_TYPE.PARTNERSHIP]: 'authorizedRepresentative',
                [BUSINESS_TYPE.NONPROFIT]: 'authorizedRepresentative',
                skipUBOForUpgrade: 'mcc',
                skipMcc: 'location'
            }
        }
    },
    dateOfBirth: {
        next: 'nationality',
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    nationality: {
        next: {
            nonSoleProp: 'sameAddressCheck',
            usNational: 'ssn',
            nonUSNational: 'usCitizenship'
        },
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    usCitizenship: {
        next: {
            confirmed: 'ssn',
            denied: 'sameAddressCheck'
        },
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    ssn: {
        next: 'backupWithholding',
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    backupWithholding: {
        next: 'sameAddressCheck',
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    sameAddressCheck: {
        next: {
            confirmed: 'phoneNumber',
            denied: 'homeAddress'
        },
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    homeAddress: {
        next: 'phoneNumber',
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    phoneNumber: {
        next: 'phoneOTP',
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    phoneOTP: {
        next: 'checkpoint',
        section: SECTIONS.PERSONAL_INFO_COLLECTION
    },
    authorizedRepresentative: {
        next: 'beneficiaryCheck',
        section: SECTIONS.UBO_COLLECTION
    },
    beneficiaryCheck: {
        next: {
            yes: 'beneficialOwner',
            no: 'companyExecutive'
        },
        section: SECTIONS.UBO_COLLECTION
    },
    beneficialOwner: {
        next: 'companyExecutive',
        section: SECTIONS.UBO_COLLECTION
    },
    companyExecutive: {
        next: 'checkpoint',
        section: SECTIONS.UBO_COLLECTION
    },
    mcc: {
        next: 'location',
        section: SECTIONS.MORE_INFO_COLLECTION
    },
    location: {
        next: 'regularity',
        section: SECTIONS.PURPOSE_NATURE_COLLECTION
    },
    regularity: {
        next: 'averageTransaction',
        section: SECTIONS.PURPOSE_NATURE_COLLECTION
    },
    averageTransaction: {
        next: 'cardTurnover',
        section: SECTIONS.PURPOSE_NATURE_COLLECTION
    },
    cardTurnover: {
        next: 'currentAnnualTurnover',
        section: SECTIONS.PURPOSE_NATURE_COLLECTION
    },
    currentAnnualTurnover: {
        next: 'expectedTurnover',
        section: SECTIONS.PURPOSE_NATURE_COLLECTION
    },
    expectedTurnover: {
        next: 'review',
        section: SECTIONS.PURPOSE_NATURE_COLLECTION
    },
    review: {
        isFinalPage: true,
        decisions: {
            NEED_DATA: 'needMoreInfo',
            IN_REVIEW: 'riskReview',
            DENIED: 'decline', // TODO when can backend return DENIED??
            DENY: 'decline',
            ACTIVATION_PENDING: 'sanctionsDecision',
            NOT_REGISTERED: 'notRegistered'
        }
    }
};

/**
 * Basically what we are trying to approach is to find the longest path of screens from first one to review screen.
 * Also, each node along with the path should have the maximum step value so that we can make sure the progress value
 * is monotonically increasing
 */
function setStepValue() {
    let nextStep = 0;

    /**
     * Considering the complexity of the screens' path, I separate it into several sections because we have clear and
     * unique first screen for each section and last screen would be always `checkpoint` except the last section
     * @param {string} firstScreen - starting screen for each section
     * @param {number} startStep - starting step for each section
     */
    function calculateStepBySection(firstScreen, startStep = 0) {
        const queue = [[firstScreen, startStep]];
        while (queue.length) {
            let [pointer, step] = queue.shift();
            const currentScreen = screenConfig[pointer];
            currentScreen.step = Math.max(step, currentScreen.step || 0);
            nextStep = Math.max(nextStep, currentScreen.step + 1);

            if (!currentScreen.isFinalPage) {
                if (
                    typeof currentScreen.next === 'string' &&
                    currentScreen.next !== 'checkpoint'
                ) {
                    queue.push([currentScreen.next, step + 1]);
                } else if (
                    currentScreen.next.toString() === '[object Object]'
                ) {
                    // there could be the possibility where some next screens point to the same destination,
                    // so we need to remove the duplicates and then put the rest into queue to have iterated.
                    queue.push(
                        ...Array.from(
                            new Set(
                                Object.values(currentScreen.next).filter(
                                    (nextScreen) => nextScreen !== 'checkpoint'
                                )
                            )
                        ).map((nextScreen) => [nextScreen, step + 1])
                    );
                }
            }
        }
    }

    calculateStepBySection(firstScreenBySections.businessInfoFirstScreen);
    calculateStepBySection(
        firstScreenBySections.personalInfoFirstScreen,
        nextStep
    );
    calculateStepBySection(firstScreenBySections.uboFirstScreen, nextStep);
    calculateStepBySection(
        firstScreenBySections.purposeNatureFirstScreen,
        nextStep
    );
}

setStepValue();

/**
 * @type {typeof screenConfig}
 */
const exportConfig = Object.assign(
    {},
    Object.entries(screenConfig).reduce((acc, cur) => {
        acc[cur[0]] = { ...cur[1] };
        return acc;
    }, {})
);

// dynamically create the page flow based on the fieldsToCollect array
// EX fieldsToCollect = [dob, nationality, address]
// dynamicScreenConfig will be designed to make page flow from dob --> nationality --> address
export const dynamicScreenConfig = (fieldsToCollect) =>
    Object.entries(screenConfig).reduce((acc, cur) => {
        if (fieldsToCollect.indexOf(cur[0]) > -1) {
            acc[cur[0]] = { ...cur[1] };
            acc[cur[0]].next =
                fieldsToCollect[fieldsToCollect.indexOf(cur[0]) + 1];
        }
        return acc;
    }, {});

export default exportConfig;
